import { Services } from '@sigma-frontend-libs/commons'

import { serviceTemplate } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: Services.servers,

      outputFilter(result) {
        result.port = parseInt(result.port)

        return result
      },

      has: {
        clone: false,
        filter: false
      },

      formClass: ''
    })
  ]
}
